<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="row otherWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/exhibitor/e-icon1.png"/><span>展厅平面图</span>
          </div>
          <div class="page-pic" v-viewer="options">
            <img :src="globalVar.imgUrl+imgObj"/>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/exhibitor/e-icon2.png"/><span>我要参展</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in exhibitor" :key="idx" @click="exhibitorHandle(item)"><v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp></p>
          </div>
          <div class="page-header-news clearfix" style="margin-top: 0px;">
            <img class="icon1" src="../../static/images/exhibitor/e-icon3.png"/><span>我是参展商</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in exhibitors" :key="idx" @click="exhibitorHandle(item)"><v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mCodeWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <img src="../../static/images/exhibitor/m-code.jpg"/>
        </div>
      </div>
    </div>
    <div class="row latesWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6 page-ad" v-for="(item,idx) in adPicWrap" :key="idx" v-show="item.state != -1" @click="topic(item)">
          <img v-if="item.state === 1" :src="globalVar.imgUrl+item.imgurl"/>
          <img v-if="item.state === 0" :src="globalVar.imgUrl+item.imgurl"/>
        </div>
      </div>
    </div>
    <div class="row four-enterWrap">
      <div class="container page-three-enter">
        <!-- <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'pdfPage',query: {name: '参展邀请函'}}"><img src="../../static/images/exhibitor/enter3-1.png"/></router-link></div> -->
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'guidePage',query: {name: '展位申请指引'}}"><img src="../../static/images/exhibitor/enter3-2.png" alt="展位申请"/></router-link></div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'pdfPage',query: {name: '参展指南'}}"><img src="../../static/images/exhibitor/enter3-4.png" alt="参展指南"/></router-link></div>
        <div class="col-xs-12 col-sm-4 col-md-4 page-four-enter"><router-link :to="{name: 'contactEPage',query: {name: '展位申请指引'}}"><img src="../../static/images/exhibitor/enter3-3.png" alt="联络展务组"></router-link></div>
      </div>
    </div>
    <div class="row exhWrap">
      <div class="container">
        <div class="col-xs-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/exhibitor/e-icon4.png"/><span>展商一览</span>
            <router-link class="more right" :to="{ name: 'SearchPage', query: { name: '展商信息' }}">更多</router-link>
          </div>
          <div class="row page-exh-list">
            <a class="col-xs-6 col-sm-4 col-md-4" v-for="(item, idx) in actor" :key="idx" :href="globalVar.pdfUrl+'/#/ExhibitorSearchDet?name=展商信息&id='+item.actorID" target="_blank"><v-clamp autoresize :max-lines="1">{{item.actorName ? item.actorName : item.actorEName}}</v-clamp></a>
          </div>
          <div class="searchMore" @click="searchMore">搜索更多展商信息</div>
        </div>
        </div>
    </div>
    <img class="p-code" src="../../static/images/exhibitor/p-code.png"/>
  </div>
</template>

<script>
import subMenuBar from '@/components/subMenuBar/subMenuBar'
import VClamp from 'vue-clamp'
export default {
  components: {
    subMenuBar,
    VClamp,
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.exhibitor,
      options: {
        "navbar": false,
        "title": false,
        "toolbar": false,
        "transition": false,
        "keyboard": false
      },
      exhibitor: [
        {
          title: '展区规划',
          pathName: 'planPage',
          name: '展馆规划'
        },{
          title: '参展对象及资质',
          pathName: 'ojbPage',
          name: '参展对象及资质'
        },{
          title: '参展收获',
          pathName: 'ExhibitorPage',
          name: '参展收获'
        },{
          title: '展位价格与配备',
          pathName: 'pricePage',
          name: '展位价格与配备'
        },{
          title: '参会客商情况',
          pathName: 'picPage',
          name: '参会客商情况'
        },{
          title: '展馆介绍',
          pathName: '',
          name: ''
        },{
          title: '主宾国活动简介',
          pathName: 'pdfPage',
          name: '主宾国活动简介'
        },{
          title: '主宾省活动简介',
          pathName: 'pdfPage',
          name: '主宾省活动简介'
        },{
          title: '参展程序',
          pathName: 'programPage',
          name: '参展程序'
        },{
          title: '网上申请展位',
          pathName: 'BoothPage',
          name: '网上报名参展'
        },{
          title: '展位申请指引',
          pathName: 'guidePage',
          name: '展位申请指引'
        },{
          title: '联络展务组',
          pathName: 'contactEPage',
          name: '联络展务组'
        }
      ],
      exhibitors: [
        {
          title: '参展日程',
          pathName: 'schedulePage',
          name: '展览日程安排'
        },{
          title: '证件办理',
          pathName: 'paperworkPage',
          name: '证件办理'
        },{
          title: '展馆管理规定',
          pathName: 'manageEPage',
          name: '展馆管理规定'
        },{
          title: '消防安全规定',
          pathName: 'safetyEPage',
          name: '消防安全规定'
        },{
          title: '展品运输指南',
          pathName: 'transportEPage',
          name: '展品运输指南'
        },{
          title: '境外展品通关',
          pathName: 'clearanceEPage',
          name: '境外展品通关'
        },{
          title: '布、撤展规定',
          pathName: 'layoutEPage',
          name: '布、撤展规定'
        },{
          title: '展馆服务',
          pathName: 'serviceEPage',
          name: '展馆服务'
        },{
          title: '联络展务组',
          pathName: 'contactEPage',
          name: '联络展务组'
        },{
          title: '联络布展商',
          pathName: 'pdfPage',
          name: '联络布展商'
        },{
          title: '在线展具租赁',
          pathName: '',
          name: ''
        },
        {
          title: '布展单位特装报馆流程',
          pathName: 'pdfPage',
          name: '布展单位特装报馆流程',
          linkUrl:'https://www.chinafair.org.cn/cifit/file/第二十一届中国国际投资贸易洽谈会特装报馆须知（对外公示）.pdf'
        },

        {
          title: '主场服务商公告及推荐搭建商资质申请',
          pathName: 'pdfPage',
          name: '主场服务商公告及推荐搭建商资质申请',
          linkUrl:'https://www.chinafair.org.cn/cifit/file/主场服务商公告及推荐搭建商资质申请.pdf'
          
        },
        {
          title: '会展码使用说明',
          pathName: 'pdfPage',
          name: '会展码使用说明',
          linkUrl:'https://www.chinafair.org.cn/cifit/file/会展码使用说明.pdf'
        },
        // {
        //   title: '参展指南下载',
        //   pathName: 'pdfPage',
        //   name: '参展指南下载'
        // },
      ],
      adPicWrap: Array,
      actor: Array,
      imgObj: '',
    }
  },
  async created(){
    await this.init();
  },
  methods: {
    subpagemenu(item){
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.subName,
        }
      })
    },
    searchMore(){
      this.$router.push({
        name: 'SearchPage',
        query: {
          name: '展商信息',
        }
      })
    },
    exhibitorHandle(item){
      if(item.title === '展馆介绍'){
        window.location.href = this.globalVar.Venues;
      }else if(item.title === '在线展具租赁'){
        window.location.href = this.globalVar.xicec;
      }
      else{
        if(item.name=='布展单位特装报馆流程')
        {
          this.$router.push(
            {
              name:"ExhibitorFileData",
              query:{
                name:"布展单位特装报馆流程",
                // linkUrl:item.linkUrl
              }
            }
          )
        }
        else if(item.linkUrl)
        {
          window.open(item.linkUrl)
        }
        else{
          this.$router.push({
            name: item.pathName,
            query: {
              name: item.name,
            }
          })
        }
        
      }
    },
    async init(){
      let data = await this.getList();//展厅平面图
      this.imgObj = data.imgurl;
      this.adPicWrap = await this.findAd();//获取广告信息
      this.actor = await this.actorlist();//展商一览列表接口
    },
    getList(){
      let params = {
          language: this.globalVar.lang,
          // sessionName: '',
          // type: 1
      }
      return this.$store.dispatch("planning", params);
    },
    findAd(){
      let params = {
          code: 'D',
          language: this.globalVar.lang
      }
      return this.$store.dispatch("findAd", params);
    },
    async topic(item){
      let params = {
        id : item.id
      }
      let data = await this.$store.dispatch("clicks", params);
      if(data.isguest === 1){
        this.$router.push({
            path: '/topic',
            query: {
                gid : data.gid
            }
        })
      }else{
        window.location.href=data.url
      }
    },
    actorlist(){
      let params = {
        language: this.globalVar.lang,
        count: 12
      }
      return this.$store.dispatch("actorlist", params);
    },
    // detail(id){
    //   this.$router.push({
    //     name: 'SearchDetEPage',
    //     query: {
    //         name: '展商信息',
    //         id: id
    //     }
    //   })
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
@import '../../static/function.less';
.otherWrap{
  margin-bottom: 1%;
  .page-header-news{
    margin-top: 3%;
  }
  .page-pic{
    padding: 2% 0;
    text-align: center;
    cursor: pointer;
  }
  .page-list{
    margin-top: 5%;
    padding: 0 3%;
    cursor: pointer;
    p{
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover{
        .hoverTxtColor()
      }
      &:before{
        content:''; 
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
  }
}
.p-code{
  width: 130px;
  height: 175px;
  position: fixed;
  bottom: 20%;
  left: 0;
}
.mCodeWrap{
  display: none;
  margin-bottom: 15px;
}
.latesWrap{
  .page-ad{
    padding: 1% 15px;
  }
}
.exhWrap{
  .page-exh-list{
    a{
      font-size: @font14;
      margin: 10px 0px;
      position: relative;
      text-indent: 1em;
      cursor: pointer;
      &:hover{
        .hoverTxtColor()
      }
      &::before{
        content: '';
        position: absolute;
        left: 16px;
        top: 8px;
        display: inline-block;  
        width: 4px;
        height: 4px;
        background-color: @colorea0e1e;
        border-radius: 50%;
      }
    }
  }
  .searchMore{
    font-size: @font14;
    margin: 20px auto 50px;
    width: 150px;
    text-align: center;
    line-height: 40px;
    border: 1px solid #666;
    cursor: pointer;
    &:hover{
      color: #fff;
      border: 1px solid @colorff4e4e;
      background-color: @colorff4e4e;
    }
  }
}
.four-enterWrap{
  width: 100%;
  margin: 2% 0px;
  font-size: 20px;
  color: #303133;
  font-weight: bold;
  padding: 3%;
  background: url('../../static/images/index/adBg.png') no-repeat center;
  background-size: cover;
  .page-three-enter{
    width: 1000px;
  }
  .page-four-enter{
    padding: 1%;
    cursor: pointer;
    text-align: center;
    a{
      display: inline-block;
    }
    &:hover{
      img{
          .shadow(4px)
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 767px){
  .slideMenu,.mCodeWrap{
    display: block;
  }
  .four-enterWrap .page-three-enter{
    width: 100%;
  }
  .p-code{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Exhibitor.vue